<!--
  ~ /**
  ~   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~   ~  * No part of this publication may be reproduced, distributed,
  ~   ~  * or transmitted in any form or by any means, including photocopying, recording,
  ~   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~   ~  * except in the case of brief quotations embodied in critical
  ~   ~  * reviews and certain other noncommercial uses permitted by copyright law.
  ~   ~  * AUTHOR : bs
  ~   ~  * DATE : 20/05/2025 14:18
  ~ **/
  -->

<div class="wrapper-page" [ngClass]="{ 'without-menu': !withMenu() }">
  <header>
    <infm-header
      [title]="showTitle() ? null : headerTitle()"
      [actions]="headerActions()"
      (actionClick)="headerActionClick.emit($event)"
    />
    @if (showTitle()) {
      <div class="title">
        @if (titleIcon()) {
          <i class="fal fa-{{ titleIcon() }}"></i>
        }
        <div class="label">{{ headerTitle() | translate }}</div>
      </div>
    }
  </header>
  <div class="wrapper-content" [ngClass]="{ 'with-title': showTitle() }">
    <ng-content></ng-content>
  </div>
</div>
